export const ADD_TO_BAG = 'add_to_bag';
export const SHOP_NOW = 'shop_now';
export const HIDE_CTA = 'hide_cta';
export const ADD_TO_COLLECTION = 'add_to_collection';
export const FIND_IN_STORE = 'find_in_store';
export const PREORDER = 'preorder';
export const LINK = 'link';
